import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import userService from "../services/user.service";
import { setMessage } from "./message";
export const fetchUserList = createAsyncThunk(
    'users/fetchUserList',
    async ({ page, pagesize, search, ordering, superuser }, thunkAPI) => {
        try {
            const response = await userService.getUsersList(page, pagesize, search, ordering, superuser);
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const fetchUserPermissionList = createAsyncThunk(
    'users/fetchUserPermissionList',
    async ({ user_id }, thunkAPI) => {
        try {
            const response = await userService.getUsersPermissionList(user_id);
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const fetchArchivedUsersList = createAsyncThunk(
    'users/fetchArchivedUsersList',
    async ({ page, pagesize, search }, thunkAPI) => {
        try {
            const response = await userService.getArchiveUsersList(page, pagesize, search);
            return response.data; // Assuming response contains { data, count, totalPages, etc. }
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);
export const fetchUserById = createAsyncThunk(
    'users/fetchUserById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await userService.getUserById(id);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const createUser = createAsyncThunk(
    'users/createUser',
    async ({ values, profilePic }, thunkAPI) => {
        try {
            const validateFile = (file) => file instanceof File;
            const formPayload = new FormData();
            const textPayload = {
                username: values.username,
                first_name: values.first_name,
                last_name: values.last_name,
                email: values.email,
                phone: values.phone,
                groups: values.groups,
                deleted: 0
            };
            formPayload.append("form_data", JSON.stringify(textPayload));

            if (profilePic && validateFile(profilePic)) {

                formPayload.append('profile_image', profilePic);
            }

            const response = await userService.createUser(formPayload);
            return response.data; // Assuming response contains the created die size data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createPassword = createAsyncThunk(
    'users/createPassword',
    async ({ values }, thunkAPI) => {
        try {
            const response = await userService.createPassword(values);
            return response.data; // Return the response data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const changePassword = createAsyncThunk(
    'users/changePassword',
    async ({ values }, thunkAPI) => {
        try {
            const response = await userService.changePassword(values);
            return response.data; // Return the response data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateUser = createAsyncThunk(
    'user/updateUser',
    async ({ id, values, profilePic }, thunkAPI) => {
        try {
            const validateFile = (file) => file instanceof File;
            const formPayload = new FormData();
            const textPayload = {
                username: values.username,
                first_name: values.first_name,
                last_name: values.last_name,
                email: values.email,
                phone: values.phone,
                groups: values.groups,
            };
            formPayload.append("form_data", JSON.stringify(textPayload));

            if (profilePic && validateFile(profilePic)) {
                formPayload.append('profile_image', profilePic);
            }
            const response = await userService.updateUser(id, formPayload);
            return response.data; // Ensure this returns the updated category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateUserStatus = createAsyncThunk(
    'user/updateUserStatus',
    async ({ payload }, thunkAPI) => {
        try {
            const response = await userService.updateUserStatus(payload);
            return response.data; // Ensure this returns the updated category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const archiveUser = createAsyncThunk(
    'user/archiveUser',
    async (id, thunkAPI) => {
        try {
            await userService.archiveUser(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unArchiveUser = createAsyncThunk(
    'user/unArchiveUser',
    async (id, thunkAPI) => {
        try {
            await userService.unArchiveUser(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);

const initialState = {
    data: [],  // Ensure the data is always an empty array initially
    list: [],
    loading: false,
    totalRecord: 0,
    totalPages: 0,
    currentPage: 1,
    status: 'idle',
    error: null,
    hasMore: true,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetUserList: (state) => {
            state.list = []; // This will clear the list
        },
        resetCurrentUserPage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchUserList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Correctly access the data array
                state.totalRecord = action.payload.count || 0; // Set total records
                state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchUserList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(fetchUserPermissionList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchUserPermissionList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.totalRecord = action.payload.count || 0; // Set total records
                state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchUserPermissionList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });


        builder
            .addCase(fetchArchivedUsersList.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedUsersList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentpage;
                state.data = action.payload.results.data || [];
                state.totalRecord = action.payload.count || 0;
                state.totalpage = action.payload.totalPages || 0;
                state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedUsersList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });


        builder
            .addCase(fetchUserById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserById.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchUserById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(createUser.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createUser.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data.push(action.payload);
            })
            .addCase(createUser.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });

        builder
            .addCase(updateUser.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateUser.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(updateUser.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });

        builder
            .addCase(updateUserStatus.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateUserStatus.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(updateUserStatus.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(archiveUser.pending, state => {
                state.status = 'loading';
            })
            .addCase(archiveUser.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(archiveUser.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(unArchiveUser.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveUser.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveUser.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export const { resetUserList, resetCurrentUserPage } = userSlice.actions;
const { reducer } = userSlice;
export default reducer;
